require('../../modules/es6.number.is-finite');
module.exports = require('../../modules/_core').Number.isFinite;



//////////////////
// WEBPACK FOOTER
// ../~/babel-runtime/~/core-js/library/fn/number/is-finite.js
// module id = 626
// module chunks = 0